<template>
  <v-app>
    <v-navigation-drawer disable-resize-watcher v-model="sidebar" app>
      <v-list class="mt-16 mobile-menu">
        <v-list-item
          v-for="item in mobileMenuList"
          :key="item.title"
          :to="item.path"
        >
          <v-list-item-icon>
            <v-icon color="#aaaaaa" v-text="item.icon"></v-icon>
          </v-list-item-icon>
          <v-list-item-content>{{ item.title }}</v-list-item-content>
        </v-list-item>
        <v-list-item v-if="!isLoggedIn">
          <v-list-item-content>
            <v-btn
              @click="
                signup = false;
                showSignUpModal = true;
              "
            >
              Login
            </v-btn>
          </v-list-item-content>
        </v-list-item>
        <v-list-group
          v-if="isLoggedIn"
          prepend-icon="account_circle"
          :value="$route.matched.some(a => a.name === 'Account')"
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Account</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
            v-for="item in mobileAccountMenuList"
            :key="item.title"
            :to="item.path"
            class="pl-10"
          >
            <v-list-item-icon>
              <v-icon color="#aaaaaa" v-text="item.icon"></v-icon>
            </v-list-item-icon>
            <v-list-item-content>{{ item.title }}</v-list-item-content>
          </v-list-item>
        </v-list-group>
      </v-list>
      <v-list class="d-none d-md-block">
        <v-list-item
          v-for="item in menuItems"
          :key="item.title"
          :to="item.path"
        >
          <v-list-item-content>{{ item.title }}</v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-btn
              @click="
                signup = false;
                showSignUpModal = true;
              "
            >
              Login
            </v-btn>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app color="appGreen">
      <v-btn
        icon
        tile
        @click="sidebar = !sidebar"
        dark
        class="d-block d-md-none"
      >
        <v-icon dark>
          mdi-menu
        </v-icon>
      </v-btn>
      <!-- <v-app-bar-nav-icon @click="sidebar = !sidebar">
        </v-app-bar-nav-icon> -->
      <v-container class="py-0">
        <v-row class="d-none d-md-flex">
          <v-avatar size="150px" height="64px" tile>
            <img :src="require('@/assets/dentoholic_logo.svg')" alt="logo" />
          </v-avatar>
          <v-spacer></v-spacer>
          <v-toolbar-items class="hidden-xs-only">
            <v-btn
              text
              color="white"
              class="gotham-book text-none font-weight-bold"
              v-for="item in menuItems"
              @click="openCategories(item, $event)"
              :key="item.title"
              :to="item.path"
            >
              {{ item.title }}
            </v-btn>
            <v-btn
              text
              color="white"
              class="gotham-book text-none font-weight-bold"
              @click="openCategories(item, $event)"
              to="/account/personal-info"
              v-if="isLoggedIn"
            >
              Account
            </v-btn>
            <v-btn
              v-if="!isLoggedIn"
              @click="
                signup = false;
                showSignUpModal = true;
              "
              rounded
              text
              color="appRed"
              class="text-none font-weight-bold"
            >
              Log in
            </v-btn>
            <div class="relative">
              <v-btn
                depressed
                rounded
                color="appRed"
                class="cart-button white--text mx-0 px-0"
                @click="dropdown = !dropdown"
              >
                <v-icon left color="white">
                  mdi-cart-outline
                </v-icon>
                <span class="counter">{{ totalBasketItems }}</span>
                <div class="indicator"></div>
              </v-btn>
              <BasketDropDown v-if="dropdown" @close="dropdown = !dropdown" />
            </div>
          </v-toolbar-items>
        </v-row>
        <v-row
          class="text-center white--text pl-10 d-flex d-md-none"
          align="center"
          v-if="$route.matched.some(a => a.name === 'Account') && isLoggedIn"
        >
          <div class="pl-10">
            <div class="menu-title mb-1">My Account</div>
            <div class="menu-sub-title">
              {{ $route.name.replace("-", " ") }}
            </div>
          </div>
        </v-row>
        <v-row
          class="text-center white--text d-flex d-md-none"
          align="center"
          v-else-if="$route.matched.some(a => a.name === 'Product')"
        >
          <div>
            <div class="menu-title">{{ product.name }}</div>
          </div>
        </v-row>
        <v-row v-else class="d-block d-md-none">
          <div class="pl-10">
            <v-avatar size="150px" height="64px" tile>
              <img :src="require('@/assets/dentoholic_logo.svg')" alt="logo" />
            </v-avatar>
          </div>
        </v-row>
        <MegaMenu v-if="showMegaMenu" @close="showMegaMenu = false" />
      </v-container>
    </v-app-bar>

    <v-main class="pb-10 pb-md-0">
      <router-view></router-view>
    </v-main>
    <v-dialog v-model="showSignUpModal" width="1100">
      <v-card class="border-radius-none signup-modal">
        <v-card-text class="pa-0">
          <div class="d-flex">
            <div
              class="flex appGreen px-10 left-body w-50 text-center white--text d-none d-md-none d-lg-block"
            >
              <div>
                <img src="@/assets/dentoholic_logo.svg" width="170px" />
              </div>
              <div>
                <h4 class="tag-line mt-8">
                  Easily compare and buy products <br />from 1000+ dental
                  suppliers...
                </h4>
              </div>
              <div class="checklist mt-10">
                <div class="d-flex align-center justify-center pl-14 mt-5">
                  <v-icon color="#FFE24D" x-large class="mr-3"
                    >mdi-check</v-icon
                  >
                  <span class="font-25 mt-1 gotham-medium flex text-left"
                    >Organise procurement</span
                  >
                </div>
                <div class="d-flex align-center justify-center pl-14 mt-5">
                  <v-icon color="#FFE24D" x-large class="mr-3"
                    >mdi-check</v-icon
                  >
                  <span class="font-25 mt-1 gotham-medium flex text-left"
                    >Save on dental supplies</span
                  >
                </div>
                <div class="d-flex align-center justify-center pl-14 mt-5">
                  <v-icon color="#FFE24D" x-large class="mr-3"
                    >mdi-check</v-icon
                  >
                  <span class="font-25 mt-1 gotham-medium flex text-left"
                    >Get dedicated support</span
                  >
                </div>
              </div>
            </div>
            <div class="flex w-50 right-body px-4 px-md-10 text-center">
              <div v-if="signup == 1">
                <h4
                  class="gotham-medium font-25 font-normal font-w-500 black--text"
                >
                  Sign up for Free
                </h4>
                <v-form class="mt-10" @submit.prevent="createUser">
                  <v-row>
                    <v-col md="6" sm="6" cols="12">
                      <v-text-field
                        label="First Name"
                        v-model="signupCredientials.firstName"
                        name="firstname"
                        class="gotham-light font-w-normal font-normal font-12"
                        color="#666666"
                        solo
                        dense
                        hide-details="auto"
                        flat
                      ></v-text-field>
                    </v-col>
                    <v-col md="6" sm="6" cols="12">
                      <v-text-field
                        label="Last Name"
                        v-model="signupCredientials.lastName"
                        name="lastname"
                        class="gotham-light font-w-normal font-normal font-12"
                        color="#666666"
                        solo
                        dense
                        hide-details="auto"
                        flat
                      ></v-text-field>
                    </v-col>
                    <v-col md="6" sm="6" cols="12">
                      <v-text-field
                        label="Email Address"
                        v-model="signupCredientials.email"
                        name="email"
                        class="gotham-light font-w-normal font-normal font-12"
                        color="#666666"
                        solo
                        dense
                        hide-details="auto"
                        flat
                      ></v-text-field>
                    </v-col>
                    <v-col md="6" sm="6" cols="12">
                      <v-text-field
                        label="Password"
                        v-model="signupCredientials.password"
                        name="password"
                        class="gotham-light font-w-normal font-normal font-12"
                        color="#666666"
                        type="password"
                        solo
                        dense
                        hide-details="auto"
                        flat
                      ></v-text-field>
                    </v-col>
                    <!-- <v-col md="6" sm="6" cols="12">
                      <v-tel-field
                        label="Phone"
                        outlined
                        v-model="signupCredientials.phone"
                      ></v-tel-field>
                    </v-col> -->
                    <v-col sm="12" md="12">
              <v-tel-field
                outlined
                v-model="signupCredientials.phone"
                hide-details="auto"
                flat
              ></v-tel-field>
              <!-- <vue-tel-input
                label="Contact Number"
                solo
                dense
                hide-details="auto"
                v-model="surgery.phone"
                :rules="surgeryRules.phone"
                flat
              ></vue-tel-input> -->
            </v-col>
                    
                    
                    
                    
                    <v-col md="6" sm="6" cols="12">
                      <v-select
                        :items="userPositions"
                        v-model="signupCredientials.userPositionId"
                        name="userposition"
                        label="Role"
                        class="gotham-light font-w-normal font-normal font-12"
                        color="#666666"
                        solo
                        flat
                        dense
                        value
                        item-text="name"
                        item-value="id"
                        hide-details="auto"
                      ></v-select>
                    </v-col>
                    <v-col md="6" sm="6" cols="12">
                      <v-text-field
                        label="GDC Number"
                        v-model="signupCredientials.GDCNumber"
                        class="gotham-light font-w-normal font-normal font-12"
                        color="#666666"
                        solo
                        dense
                        hide-details="auto"
                        flat
                      ></v-text-field>
                    </v-col>
                     <v-col md="12" sm="6" cols="12">
                      <v-text-field
                        label="Surgery (if applicable)"
                        v-model="signupCredientials.surgeryName"
                        class="gotham-light font-w-normal font-normal font-12"
                        color="#666666"
                        solo
                        dense
                        hide-details="auto"
                        flat
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row class="mt-6">
                    <v-col>
                      <v-btn
                        type="submit"
                        block
                        color="appGreen white--text gotham-medium font-bold font-16"
                      >
                        SIGN UP
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row class="text-center">
                    <v-col>
                      <a
                        @click="signup = 0"
                        class="black--text gotham-medium font-normal font-w-500 font-20"
                        ><u> Already have an account? Login here...</u></a
                      >
                    </v-col>
                  </v-row>
                </v-form>
              </div>
              <div v-if="signup == 0">
                <h4
                  class="gotham-medium font-25 font-normal font-w-500 black--text"
                >
                  Login
                </h4>
                <v-form class="mt-10" @submit.prevent="login">
                  <v-row>
                    <v-col md="12" sm="12" cols="12">
                      <v-text-field
                        label="Email Address"
                        v-model="loginCredientials.email"
                        class="gotham-light font-w-normal font-normal font-12"
                        color="#666666"
                        solo
                        dense
                        hide-details="auto"
                        flat
                      ></v-text-field>
                    </v-col>
                    <v-col md="12" sm="6" cols="12">
                      <v-text-field
                        label="Password"
                        v-model="loginCredientials.password"
                        class="gotham-light font-w-normal font-normal font-12"
                        type="password"
                        color="#666666"
                        solo
                        dense
                        hide-details="auto"
                        flat
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" class="py-0 text-right">
                      <a @click="signup = 3"> Forgot Password?</a>
                    </v-col>
                  </v-row>
                  <v-row class="mt-6">
                    <v-col>
                      <v-btn
                        block
                        type="submit"
                        color="appGreen white--text gotham-medium font-bold font-16"
                      >
                        LOGIN
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row class="text-center">
                    <v-col>
                      <a
                        @click="signup = 1"
                        class="black--text gotham-medium font-normal font-w-500 font-20"
                        ><u> Don't Have a account? Signup here...</u></a
                      >
                    </v-col>
                  </v-row>
                </v-form>
              </div>
              <div v-if="signup == 3">
                <v-form @submit.prevent="reset" ref="resetForm">
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        label="Email"
                        v-model="resetPassword.email"
                        :rules="resetEmailRules"
                        class="gotham-light font-w-normal font-normal font-12"
                        type="email"
                        color="#666666"
                        solo
                        dense
                        hide-details="auto"
                        outlined
                      ></v-text-field>
                    </v-col>
                     <v-col cols="12" class="py-0 text-right">
                      <a @click="signup = 0"> Back to Login</a>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-btn
                        block
                        type="submit"
                        color="appGreen white--text gotham-medium font-bold font-16"
                      >
                        Reset Password
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-form>
              </div>
              <div v-if="signup == 4">
                <v-form @submit.prevent="setPassword" ref="resetPasswordForm">
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        label="Password"
                        v-model="resetPassword.password"
                        :rules="resetPasswordRules"
                        class="gotham-light font-w-normal font-normal font-12"
                        type="password"
                        color="#666666"
                        solo
                        dense
                        hide-details="auto"
                        outlined
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-btn
                        block
                        type="submit"
                        color="appGreen white--text gotham-medium font-bold font-16"
                      >
                        Reset Password
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-form>
              </div>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import MegaMenu from "@/components/Shared/MegaMenu/MegaMenu.vue";
import BasketDropDown from "@/components/Shared/BasketDropDown/BasketDropDown.vue";
import VueCookie from "vue-cookie";
import auth from "@/auth/auth.js";
import { mapGetters, mapState } from "vuex";

export default {
  name: "App",
  data() {
    return {
      loginCredientials: {
        email: "",
        password: ""
      },
      showSignUpModal: false,
      showForgetPassword: false,
      signup: 0,
      appTitle: "Dentoholic",
      sidebar: false,
      menuItems: [
        { title: "Home", path: "/" },
        { title: "Categories", path: "" },
        { title: "Supplier", path: "/supplier" },
        { title: "Contact", path: "/contact" }
      ],
      showMegaMenu: false,
      dropdown: false,
      signupCredientials: {
        firstName: "",
        lastName: "",
        email: "",
        password: "",
        passwordConfirmation: "",
        phone: "",
        userPositionId: "",
        GDCNumber: "",
        surgeryName: "",

      },
      resetPassword: {
        email: "",
        password: ""
      },
      resetPasswordRules: [
        v => !!v || "Password is required",
        v => (v && v.length >= 6) || "Password must be at least 6 characters",
        v => (v && v.length <= 15) || "Password must be at least 15 characters"
      ],
      resetEmailRules: [
        v => !!v || "E-mail is required",
        v => /.+@.+\..+/.test(v) || "E-mail must be valid"
      ],
      signRules: {
        firstName: [
          v => !!v || "First name is required",
          v =>
            (v && v.length >= 3) || "First name must be at least 3 characters",
          v =>
            (v && v.length <= 35) ||
            "First name must be less than than 35 characters"
        ],
        lastName: [
          v => !!v || "Last name is required",
          v =>
            (v && v.length >= 3) || "Last name must be at least 3 characters",
          v =>
            (v && v.length <= 35) ||
            "Last name must be less than than 35 characters"
        ],
        email: [
          v => !!v || "E-mail is required",
          v => /.+@.+\..+/.test(v) || "E-mail must be valid"
        ],
        password: [
          v => !!v || "Password is required",
          v => (v && v.length >= 6) || "Password must be at least 6 characters",
          v =>
            (v && v.length <= 15) || "Password must be at least 15 characters"
        ],
        phoneNumber: [
          v => !!v || "Phone is required",
          v => (v && v.length >= 4) || "Phone must be at least 4 characters",
          v =>
            (v && v.length <= 20) ||
            "Phone must be less than than 20 characters"
        ],
        userPosition: [v => !!v || "User position is required"]
      }
    };
  },
  computed: {
    ...mapGetters({
      totalBasketItems: "product/totalBasketItems",
      isLoggedIn: "auth/IS_LOGGED_IN"
    }),
    ...mapState({
      userPositions: state => state.user.userPositions,
      product: state => state.product.product
    }),
    mobileAccountMenuList() {
      return [
        {
          title: "Company Info",
          path: "/account/company-info",
          icon: "mdi-city"
        },
        {
          title: "Personal Info",
          path: "/account/personal-info",
          icon: "mdi-account"
        },
        {
          title: "Team",
          path: "/account/team",
          icon: "mdi-group"
        },
        {
          title: "Billing",
          path: "/account/billing",
          icon: "mdi-credit-card"
        },
        { title: "Password", path: "/account/password", icon: "mdi-lock" },
        { title: "Order", path: "/account/orders", icon: "mdi-medical-bag" },
        { title: "Favourite", path: "/account/favourite", icon: "mdi-heart" }
      ];
    },
    mobileMenuList() {
      return [
        { title: "Home", path: "/", icon: "mdi-home" },
        { title: "Supplier", path: "/supplier", icon: "mdi-group" },
        { title: "Contact", path: "/contact", icon: "mdi-contacts" }
      ];
    }
  },
  components: {
    MegaMenu,
    BasketDropDown
  },
  beforeMount() {
    this.$store.commit("auth/SET_TOKEN", VueCookie.get("token"));
    this.$store.commit(
      "auth/SET_USER",
      auth.decodeToken(VueCookie.get("token"))
    );
    this.$store.commit("product/CHECK_BASKET_AND_SET");
  },
  mounted() {
    this.$store.dispatch("user/GET_USER_POSITIONS");
    this.$store.dispatch("product/GET_CATEGORIES");
    if (this.$router.currentRoute.path == '/login') {
      this.showSignUpModal = true;
    }
    if (VueCookie.get("reset-token")) {
      this.resetToken = VueCookie.get("reset-token");
      this.signup = 4;
      this.showSignUpModal = true;
      VueCookie.delete("reset-token");
    }
  },
  methods: {
    async reset() {
      if (this.$refs.resetForm.validate()) {
        this.$swal({
          title: "Send password reset request",
          text: "Please hold on for a moment",
          icon: "info",
          onOpen: () => {
            this.$swal.showLoading();
          }
        });
        await this.$store.dispatch("auth/RESET_PASSWORD_EMAIL", {
          email: this.resetPassword.email
        });
        this.$swal.close();
        this.$swal({
          title: "Success",
          text: "Please check your email"
        });
      }
    },
    async setPassword() {
      if (this.$refs.resetPasswordForm.validate()) {
        this.$swal({
          title: "Reseting your password",
          text: "Please hold on for a moment",
          icon: "info",
          onOpen: () => {
            this.$swal.showLoading();
          }
        });
        await this.$store.dispatch("auth/RESET_PASSWORD", {
          id: this.resetToken,
          password: this.resetPassword.password
        });
        this.$swal.close();
        this.$swal({
          title: "Success",
          text: "Your password is reset, you can login now.",
          icon: "info"
        });
      }
    },
    async createUser() {
      this.$swal({
        title: "Signing up",
        text: "Setting up your account... This will only take a minute",
        icon: "info",
        onOpen: () => {
          this.$swal.showLoading();
        }
      });
      await this.$store.dispatch("auth/SIGNUP_SURGERY", this.signupCredientials).then(() => {
            this.$swal({
              title: "Your Account has been created!",
              text: "You can now log in",
              icon: "success"
             });
      this.showSignUpModal = false;
          
      }).catch((error) => {
            this.showError(error.message);
            this.$swal({
              title: "Something went wrong",
              html: error.message,
              icon: "error"
            });
          
      });
      
    },
    async login() {
      this.$swal({
        title: "loggin in",
        text: "Please hold on for a moment",
        icon: "info",
        onOpen: () => {
          this.$swal.showLoading();
        }
      });
      await this.$store.dispatch("auth/LOGIN", this.loginCredientials);
      this.$swal.close();
      this.showSignUpModal = false;
    },
    openCategories(item, e) {
      e.preventDefault();
      if (item.title === "Categories") {
        this.showMegaMenu = !this.showMegaMenu;
      }
    }
  }
};
</script>
<style lang="scss" src="./App.scss">
.signup-modal {
  .vue-tel-input-vuetify .v-text-field--solo-flat .v-input__slot .v-label {
    top: 10px;
  }
  .vue-tel-input-vuetify .v-text-field--solo-flat .v-input__slot .v-label {
    top: 17px;
    left: 11px !important;
  }
  .country-code .v-input__slot .v-input__append-inner {
    margin-top: 15px !important;
  }
}


</style>

